import { Pipe, PipeTransform } from '@angular/core';
import { isAnonymous } from '../../helper/peerHelper';

@Pipe({
   name: 'isAnonymous',
})
export class IsAnonymousPipe implements PipeTransform {
   transform(comparison: string): boolean {
      return isAnonymous(comparison);
   }
}
